import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AbLogWebHook } from 'app/abstract/full-pages/log-webhook/log-webhook.abstract';
import { AppFilter } from 'app/models/app-filter.model';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LogWebhookService extends AbLogWebHook {

  constructor(http: HttpClient) {
    super(http);
  }

  public getAllWebhook(filter: AppFilter): Observable<any> {
    return this.get(`admin/log_webhook/filter/${filter.encode()}`);
  }

  public getWebhook(id: number): Observable<any> {
    return this.get("admin/log_webhook/", id);
  }

}